import DesBreadcrumbViewModel from 'viewmodel/DesBreadcrumbViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesBreadcrumb extends DesBaseCatalogAcc {
    constructor() {
        super(DesBreadcrumbViewModel);
    }

    get crumb() {
        return this.getAttribute('crumb');
    }

    get view() {
        return this.getAttribute('view');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get provider() {
        return this.getAttribute('provider');
    }

    get crumbObj() {
        return this.getAttribute('crumb-obj') || this.getAttribute('crumbobj');
    }

    getProps() {
        return {
            crumb: this.crumb,
            provider: this.provider,
            view: this.view,
            crumbobj: this.crumbObj
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'crumb', 'provider', 'locale', 'view', 'crumb-obj', 'crumbobj'];
    }
}

if (!window.customElements.get('des-breadcrumb')) {
    window.customElements.define('des-breadcrumb', DesBreadcrumb);
}
